import { Service } from '../Service'

const ENDPOINTS = {
  GET: 'CompanyRemarks/Get',
  GET_DYNAMIC: 'CompanyRemarks/GetAllDynamic',
  POST: 'CompanyRemarks/Create',
  PATCH: 'CompanyRemarks/Patch',
  PUT: 'CompanyRemarks/Put',
  DELETE: 'CompanyRemarks/Delete'
}

class ModuleServiceCompanyRemarks extends Service {
  async getByCompanyID ({ companyID, id }) {
    const filter = [
      companyID && `companyID == ${companyID}`,
      id !== undefined && `companyRemarkSubject.id == ${id}`
    ].filter((v) => !!v)
      .join(' && ')
    return this.getAllDynamic({ filter })
  }
}

export const ServiceCompanyRemarks = new ModuleServiceCompanyRemarks({
  apiGet: ENDPOINTS.GET,
  apiGetDynamic: ENDPOINTS.GET_DYNAMIC,
  apiPost: ENDPOINTS.POST,
  apiPatch: ENDPOINTS.PATCH,
  apiPut: ENDPOINTS.PUT,
  apiDelete: ENDPOINTS.DELETE
})
